import React from 'react';
import Header from './component/Header';
import PublicFooter from '../components/layout/PublicFooter';
import StaticPageLayout from '../components/layout/StaticPageLayout';
import { Section, Card } from '../components/ui';
import SEO from '../components/SEO';

const steps = [
    {
        number: '1',
        title: 'Vehicle Registration Information',
        description: "Start by providing your vehicle's details, including the license plate number and other relevant information. This step helps us identify your vehicle and its registration requirements.",
    },
    {
        number: '2',
        title: 'Select Your Municipality and State',
        description: 'Choose your municipality and state from our extensive list of options. Our app covers a wide range of locations, ensuring that you can always find your specific municipality for accurate renewal processing.',
    },
    {
        number: '3',
        title: 'Secure Payment Setup',
        description: 'Add your payment information to your account securely. We use encryption and robust security measures to protect your sensitive data. Rest assured that your payment details are safe and protected.',
    },
    {
        number: '4',
        title: 'Automatic Renewal Activation',
        description: "Enable our automatic renewal feature to ensure your vehicle's plate registration renews automatically each year. Say goodbye to the hassle of remembering renewal dates or dealing with late fees.",
    },
    {
        number: '5',
        title: 'Receive Timely Notifications',
        description: "We'll send you notifications and reminders as your renewal date approaches. Stay informed about the renewal process, review your payment, and make any necessary updates with ease.",
    },
    {
        number: '6',
        title: 'Renewal Confirmation',
        description: "After successful payment processing, you'll receive a confirmation of your plate renewal. You can access your renewed registration details within the app and obtain a digital copy for your records.",
    },
    {
        number: '7',
        title: 'Enjoy Peace of Mind',
        description: 'With Renew My Tech, managing your vehicle registration is simple and stress-free. Say goodbye to manual renewals and hello to a smarter, more efficient way of keeping your plate registration up to date.',
    },
    {
        number: '8',
        title: 'Customer Support',
        description: 'Our dedicated customer support team is ready to assist you. Whether you have questions or need help, feel free to reach out through our in-app chat or email support.',
    },
    {
        number: '9',
        title: 'Get Started Today',
        description: 'Join our community of satisfied users and let Renew My Tech take care of your vehicle renewal needs. Experience the future of hassle-free registration renewal. Sign up today and enjoy peace of mind.',
    },
];

const HowItWorks = () => {
    return (
        <div style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
            <SEO
                title="How It Works"
                description="Learn how RMT automates your vehicle tag renewal in 4 simple steps. Enter your plate info, select your county, set up payment, and we handle the rest."
                canonical="/how/works"
            />
            <Header />
            <StaticPageLayout
                title="How Renew My Tech Works"
                subtitle="Discover how our platform simplifies the process of managing your vehicle registration renewals."
            >
                <div className="tw-space-y-6">
                    {steps.map((step) => (
                        <div key={step.number} className="tw-flex tw-gap-5">
                            <div className="tw-flex-shrink-0 tw-w-10 tw-h-10 tw-rounded-full tw-bg-primary-500 tw-text-white tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-sm tw-shadow-md tw-shadow-primary-200">
                                {step.number}
                            </div>
                            <div className="tw-flex-1 tw-pb-6 tw-border-b tw-border-gray-100 last:tw-border-b-0">
                                <h3 className="tw-text-xl tw-text-gray-900 tw-m-0 tw-mb-2">{step.title}</h3>
                                <p className="tw-text-sm tw-text-gray-600 tw-m-0 tw-leading-relaxed">{step.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </StaticPageLayout>
            <PublicFooter />
        </div>
    );
};

export default HowItWorks;
